import { Inject } from 'inversify-props'
import { Titulo, EntradaDeTitulo, SituacaoDoTitulo } from '@/models'
import { TituloServiceAdapter } from '../adapter/TituloServiceAdapter';

export class SaveContasAPagarUseCase {
	@Inject('TituloServiceAdapter')
	private tituloServiceAdapter!: TituloServiceAdapter

	async execute(titulo: EntradaDeTitulo): Promise<Titulo> {
		return !titulo.id
			? this.tituloServiceAdapter.create(titulo)
			: this.tituloServiceAdapter.update(titulo)
	}
	
	async updateTitulos(titulosId: string[], situacaoDoTitulo: SituacaoDoTitulo): Promise<void> {
		if (!titulosId) {
			this.tituloServiceAdapter.updateTitulos(titulosId, situacaoDoTitulo)
		}
	}
}
